import React from "react";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { OcrProcessStatus } from "@/shared/config/globals";


interface Props {
  passbookType: string; // 明細帳タイプ
  authorizationStatus: number; // 認証ステータス
  index: string;
  passbookName: string; // 明細帳名
  new?: boolean; // 明細更新済み
  balance?: string; // 残高
  maintenance?: boolean; // メンテナンスフラグ
  onClick?: () => void; // クリック時処理
  onReauth?: () => void; // 再認可クリック時処理
  ocrProcessStatus?: number; // OCR処理状況
  isAggPolling?: boolean; 
  isOwner?: boolean; // アカウント所有者かどうか
  syncJump?: boolean; // 明細ジャンプフラグ
}

export const AccountsListElement = (props: Props) => {
  const reauth = props.authorizationStatus === 2;
  const listClassType = () => {
    if (props.new) {
      return "new ";
    } else if (props.maintenance) {
      return "maintenance";
    } else if (props.authorizationStatus === 2) {
      return "error"; // 再認可が必要
    } else if (props.ocrProcessStatus === OcrProcessStatus.Processing || props.isAggPolling) {
      return "loading";
    } else {
      return "";
    }
  };

  const setPassbookType = () => {
    switch (props.passbookType) {
      case "01":
      case "09":
        return "bank"; // 銀行
      case "03":
      case "19659":
      case "19660":
        return "card"; // クレカ
      case "10":
        return "emoney"; // 電子マネー
      case "20":
        return "ecshop"; // ECショップ
      case "201":
      case "202":
        return "excel"; // CSV・EXCEL
      case "101":
        return "ocr"; // OCR
      default:
        return ""; // その他
    }
  }

  const separateCommas = (value: string) => {
    // 数字以外の値が含まれる場合「エラー」で返す (マイナス符合も許容)
    if (!/^-?\d+$/.test(value)) {
      return "エラー";
    }
    // 3桁ごとにカンマを挿入して返す
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  //const capitalize = (str: string) => str?.[0]?.toUpperCase() + str?.slice(1);

  return (
    <li className={listClassType()}>
      <dl>
        <dt className={setPassbookType()}>{props.authorizationStatus === 4 ? `【無効】${props.passbookName}` : props.passbookName}</dt>
        {props.ocrProcessStatus !== OcrProcessStatus.Processing && !props.isAggPolling && props.balance && !["error", "maintenance"].includes(listClassType()) && <dd><strong>{separateCommas(props.balance)}</strong></dd>}
        {(props.ocrProcessStatus === OcrProcessStatus.Processing || props.isAggPolling) && <dd><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></dd>}
        {(props.maintenance || reauth) && <dd></dd>}
        {/* {props.ocrProcessStatus === OcrProcessStatus.Processing && <dd><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></dd>} */}
      </dl>
      {reauth && props.isOwner && !props.syncJump && (
        <BaseRoundButton
          buttonText={<em>再認証</em>}
          className={"open-modal reboot"}
          onClick={props.onReauth}
        />
      )}
      <BaseRoundButton
        className="ctrl-list"
        //id={`btn${capitalize(listClassType())}${("00" + props.index).slice(-3)}`}
        onClick={props.onClick}
      />
    </li>
  );
};